import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button, PickerDialog, InlineNotice } from '@wit-support/ui';
import { filterTemplatesByName, TemplatePicker } from '@wit-support/ui-domain';
import { AlertTriangle } from 'lucide-react';
import { fetchTemplates } from './bulk-data.js';
import { useBulkAction } from './use-bulk-action.js';
/**
 * Bulk «Письмо» dialog: pick ONE template and send it IMMEDIATELY to every
 * selected conversation (`send_reply`). A prominent warning makes the
 * immediate-send to N recipients explicit before the operator confirms.
 */
export function BulkTemplateDialog({ open, conversationIds, onOpenChange, }) {
    const [search, setSearch] = useState('');
    const [templateId, setTemplateId] = useState(null);
    const query = useQuery({
        queryKey: ['templates'],
        queryFn: fetchTemplates,
        enabled: open,
        staleTime: 60_000,
    });
    // useBulkAction owns the post-apply selection handling; the dialog just closes.
    const mut = useBulkAction(() => {
        onOpenChange(false);
        setTemplateId(null);
        setSearch('');
    });
    const count = conversationIds.length;
    const filtered = useMemo(() => filterTemplatesByName(query.data, search), [query.data, search]);
    return (_jsxs(PickerDialog, { open: open, onOpenChange: onOpenChange, busy: mut.isPending, onReset: () => {
            setTemplateId(null);
            setSearch('');
        }, title: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E", description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D \u2014 \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u0441\u0440\u0430\u0437\u0443.", footer: _jsx(Button, { type: "button", onClick: () => {
                if (!templateId)
                    return;
                mut.mutate({
                    conversationIds,
                    action: { type: 'send_reply', templateId: templateId },
                });
            }, disabled: !templateId || mut.isPending || count === 0, children: mut.isPending ? 'Отправка…' : `Отправить (${count})` }), children: [_jsx(InlineNotice, { bordered: true, icon: AlertTriangle, children: _jsxs("span", { children: ["\u041F\u0438\u0441\u044C\u043C\u043E \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u041D\u0415\u041C\u0415\u0414\u041B\u0415\u041D\u041D\u041E ", count, " ", count === 1 ? 'получателю' : 'получателям', ". \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E."] }) }), _jsx(TemplatePicker, { templates: filtered, isLoading: query.isLoading, search: search, onSearchChange: setSearch, onPick: (t) => setTemplateId(t.id), selectedId: templateId, disabled: mut.isPending, listContainerClassName: "min-h-0 flex-1 overflow-auto", listClassName: "flex flex-col gap-1.5", nameClassName: "w-full truncate text-sm font-medium", emptyMessage: "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B." })] }));
}
//# sourceMappingURL=bulk-template-dialog.js.map